// ③ 升级之路：闯荡江湖（作者 11-03：主题从进京赶考改为武侠江湖）。级数 2 → A 对应 13 站，打过 A 即“问鼎武林”。
// 站名用通用江湖地名，不用武侠小说里的专有地名。只是表现，不影响规则。
export const STATIONS: Record<number, string> = {
  2: '山门', 3: '竹林', 4: '茶寮', 5: '渡口', 6: '客栈', 7: '镖局', 8: '擂台',
  9: '古寺', 10: '峡谷', 11: '剑阁', 12: '云海', 13: '绝顶', 14: '论道台',
};
export const stationOf = (level: number): string => STATIONS[level] ?? '';
